import React from "react";

const PARTS = [
  { label: "Crash cymbal", x: 150, y: 70, tx: 40, ty: 30 },
  { label: "Hi-hat", x: 120, y: 150, tx: 20, ty: 205 },
  { label: "High tom", x: 300, y: 120, tx: 255, ty: 30 },
  { label: "Mid tom", x: 410, y: 120, tx: 395, ty: 30 },
  { label: "Ride cymbal", x: 560, y: 75, tx: 590, ty: 30 },
  { label: "Snare drum", x: 220, y: 215, tx: 120, ty: 290 },
  { label: "Bass drum", x: 355, y: 230, tx: 320, ty: 300 },
  { label: "Floor tom", x: 545, y: 220, tx: 600, ty: 290 },
];

// A simple labelled drum kit, front view.
export const DrumKitDiagram = ({ testId = "drum-kit-diagram" }) => (
  <figure className="mt-5 rounded-2xl border border-border bg-card p-4" data-testid={testId}>
    <svg viewBox="0 0 720 310" className="w-full" role="img" aria-label="Labelled drum kit: crash cymbal, hi-hat, high tom, mid tom, ride cymbal, snare drum, bass drum and floor tom">
      <ellipse cx="150" cy="70" rx="70" ry="10" fill="#D4A017" /><line x1="150" y1="70" x2="150" y2="280" stroke="#A8A29E" strokeWidth="3" />
      <ellipse cx="560" cy="75" rx="80" ry="11" fill="#D4A017" /><line x1="560" y1="75" x2="560" y2="200" stroke="#A8A29E" strokeWidth="3" />
      <ellipse cx="110" cy="145" rx="48" ry="7" fill="#D4A017" /><ellipse cx="110" cy="153" rx="48" ry="7" fill="#B8860B" /><line x1="110" y1="153" x2="110" y2="290" stroke="#A8A29E" strokeWidth="3" />
      <circle cx="355" cy="215" r="80" fill="#7F1D1D" stroke="#E7E5E4" strokeWidth="6" /><circle cx="355" cy="215" r="30" fill="#0B0D12" opacity="0.35" />
      <rect x="265" y="100" width="70" height="50" rx="8" fill="#991B1B" stroke="#E7E5E4" strokeWidth="3" />
      <rect x="375" y="100" width="80" height="55" rx="8" fill="#991B1B" stroke="#E7E5E4" strokeWidth="3" />
      <rect x="170" y="195" width="100" height="40" rx="6" fill="#D6D3D1" stroke="#78716C" strokeWidth="3" /><line x1="220" y1="235" x2="220" y2="290" stroke="#A8A29E" strokeWidth="3" />
      <rect x="490" y="180" width="110" height="95" rx="8" fill="#991B1B" stroke="#E7E5E4" strokeWidth="3" />
      {PARTS.map((p) => (
        <g key={p.label}>
          <line x1={p.x} y1={p.y} x2={p.tx + 20} y2={p.ty + (p.ty < p.y ? 6 : -14)} stroke="#F59E0B" strokeWidth="1.5" />
          <circle cx={p.x} cy={p.y} r="3.5" fill="#F59E0B" />
          <text x={p.tx} y={p.ty} fontSize="16" fontWeight="700" fill="currentColor" data-testid={`${testId}-label-${p.label.split(" ")[0].toLowerCase()}`}>{p.label}</text>
        </g>
      ))}
    </svg>
    <figcaption className="mt-2 text-center text-xs text-muted-foreground">The drum kit. Low drums (bass drum, floor tom) sit low on the drum score; cymbals are written with X noteheads above.</figcaption>
  </figure>
);
